<template>
  <div class="account-log">
    <div class="content-header">
      <div class="left">
        <span class="title">账户记录</span>
      </div>
    </div>

    <Tabs v-model="activeTab" class="account-record-tabs" :animated="false" @on-click="handleTabChange">
      <TabPane label="充值记录" name="recharge" lazy>
        <recharge-record />
      </TabPane>
      <TabPane label="清零记录" name="clear" lazy>
        <money-clear-record ref="moneyClearRecord" />
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import RechargeRecord from '@/view/company/recharge'
import MoneyClearRecord from '@/view/company/money-clear-log'

export default {
  name: 'CompanyAccountLog',
  components: {
    RechargeRecord,
    MoneyClearRecord
  },
  data () {
    return {
      activeTab: this.$route.query.tab === 'clear' ? 'clear' : 'recharge'
    }
  },
  mounted () {
    if (this.activeTab === 'clear') this.handleTabChange('clear')
  },
  methods: {
    handleTabChange (name) {
      if (name !== 'clear') return
      this.$nextTick(() => {
        if (this.$refs.moneyClearRecord) this.$refs.moneyClearRecord.refreshTable()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.account-log {
  padding-top: 24px;

  > .content-header {
    border-bottom: 0;
    padding: 0;
    margin: 0 0 27px -4px;
    line-height: 29px;

    .left {
      margin: 0;
    }

    .title {
      font-size: 24px;
      line-height: 29px;
      color: #000;
      font-weight: bold;
    }
  }

  .account-record-tabs {
    margin: 0 -18px 0 -4px;

    /deep/ .ivu-tabs-bar {
      margin-bottom: 16px;
      border-bottom: 1px solid #dcdee2;
    }

    /deep/ .ivu-tabs-nav-container {
      line-height: 22px;
    }

    /deep/ .ivu-tabs-nav .ivu-tabs-tab {
      margin-right: 40px;
      padding: 0 0 6px;
      font-size: 16px;
      line-height: 22px;
      color: #000;
      font-weight: bold;
    }

    /deep/ .ivu-tabs-nav .ivu-tabs-tab-active {
      color: #2d8cf0;
    }

    /deep/ .ivu-tabs-ink-bar {
      display: none;
    }
  }
}
</style>
